import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSession } from '../context/Session';
import { hasPermissions } from '../utils';

interface Props {
  requiredPermissions: string[] | string[][] | undefined;
}
export const RequireAuth = ({ requiredPermissions }: Props) => {
  const location = useLocation();
  const session = useSession();

  if (!session.authenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const authorized = hasPermissions(session.permissions, requiredPermissions);

  return authorized ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};
